<template>
  <div class="w-form">
    <form
      id="email-form"
      name="email-form"
      data-name="Email Form"
      class="w-clearfix"
      @submit.prevent="postComment()"
    >
      <label for="node" class="field-label">
        שיח ותגובות
        <br />
      </label>
      <input
        type="text"
        class="text-field w-input"
        maxlength="256"
        data-name="כותרת"
        placeholder="כותרת"
        v-model="comment.title"
        id="node"
      />
      <div id="app">
        <editor class="text-field big w-input" v-model="comment.content" placeholder="הוסף שאלה או הערה..."
          api-key="0osf650psj1649yurge59pgmpyar9h76bwjlxcrgrrnayxmu"
          :init="intObj"
        />
      </div>
      <br />
      <smart-button :loading="false">שליחה</smart-button>
    </form>

<!--    <div class="w-form-done" v-if="this.success">-->
<!--      <div>תגובתך נשלחה בהצלחה</div>-->
<!--    </div>-->
<!--    <div class="w-form-fail" v-if="this.error">-->
<!--      <div>חלה שגיאה בשליחת התגובה. אנא נסה שנית מאוחר יותר</div>-->
<!--    </div>-->

    <div class="forum">
      <div v-for="comment in getComments" :key="comment._id">
        <singleComment :comment="comment" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import smartButton from "./button.vue";
import { DATA_LOADING_STATE } from "@/store/enums";
import singleComment from "./single_forum_comment";
import Editor from "@tinymce/tinymce-vue";
// import { flagger } from "../store/plugin.min.js"

export default {
  name: "lessonForumAddMessage",
  data() {
    return {
      comment: {
        title: "",
        content: "",
      },
      intObj:null
    };
  },
  components: {
    smartButton,
    singleComment,
    editor: Editor,
  },
  mounted(){
    this.intObj = {
         directionality:'rtl',
         height: 230,
         menubar: false,
         branding: false,
         word_counting: false,
         resize: false,
         statusbar: false,
         content_css:'/richtext/style.css',
         plugins: [
           'advlist autolink lists link image charmap print preview anchor',
           'searchreplace visualblocks fullscreen',
           'insertdatetime media table'
         ],
         toolbar:
           'undo redo | bold italic backcolor | \
            | \
           bullist numlist outdent indent',
       }
       
  },
  computed: {
    loading() {
      return this.getLoading === DATA_LOADING_STATE.CREATING;
    },
    error() {
      return this.getLoading === DATA_LOADING_STATE.ERROR;
    },
    success() {
      return this.getLoading === DATA_LOADING_STATE.CREATED;
    },
    getSelectedPath(){
      return this.$store.getters.getSelectedPath;
    },
    getComments() {
      return this.$store.getters.getComments;
    },
    ...mapGetters(["getLoading", "getErrMsg", "getUser", "getComments"]),
  },
  methods: {
    postComment() {
      let form = this.comment;
      console.log(this.$store.getters.getSelectedChapter)
      console.log("this is the form:");
      console.log(this.comment);
      this.$store.dispatch("postComment", form);
    },
  },
  // mounted() {
  //   console.log("mounted!");
  //   this.$store.dispatch("fetchComments");
  // },
};
</script>



<style >
[title=Fullscreen]{
  float: right;
}
.tox-toolbar__group{
  border-color:  #2E5BFF25 !important;
}
.tox .tox-dialog{
  /* border:none !important; */
  border-radius: 12px!important;
}
.tox .tox-editor-header {
    z-index: auto !important;
    /* border: none !important; */
    }
    .tox .tox-toolbar, .tox .tox-toolbar__overflow, .tox .tox-toolbar__primary{
      background: #f6f6f6 !important;
    }
    .tox-tinymce{
      border: none!important;
      padding: 2px;
    }
    .tox .tox-tbtn--enabled{
      background: #88ca4e !important;
      color: white !important;
    }
    .tox-tbtn--enabled svg{
      fill: white !important;
    }
    .tox-tbtn--enabled:hover svg{
      fill:  #222F3E !important;
    }
    .tox-tbtn--enabled:hover {
      color:  #222F3E !important;
    }
    .tox-tbtn:hover{
      background: #2E5BFF25 !important;
    }
    .tox-editor-container{
      @apply rounded
    }
    .tox .tox-collection--list .tox-collection__item--active{
      background: #88ca4e !important;
    }
      .tox-notifications-container {
        display: none !important;
}
      .top-menu.ftf.w-clearfix {
        display: none;
      }

</style>